import { composeStore } from 'owa-mail-compose-store';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export default function getCurrentDeepLinkRoute() {
    const route: string[] = [];

    route.push(isHostAppFeatureEnabled('opxDeeplink') ? 'opxdeeplink' : 'deeplink');

    if (composeStore.primaryComposeId) {
        route.push('compose');

        const composeViewState = composeStore.viewStates.get(composeStore.primaryComposeId);

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (17,13): Object is possibly 'undefined'.
        // @ts-expect-error
        if (composeViewState.itemId?.Id) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (21,24): Object is possibly 'undefined'.
            // @ts-expect-error
            route.push(composeViewState.itemId.Id);
        }
    }

    return route;
}
